<template>
  <router-link
    custom
    :to="route"
    v-slot="{ navigate }">
      <div @click="navigate" class="is-flex index-row align-center cursor-pointer hoverable">
        <avatar
          v-if="hasAvatar"
          class="flex-shrink-none"
          :size="48"
          :path="avatar.path"
          :name="avatar.name"
        />

        <flex column class="flex-grow mlr-1">
          <span
            class="has-text-weight-semibold is-size-5">
            {{ title }}
          </span>
          <slot />
        </flex>

        <slot name="right"/>
      </div>
  </router-link>
</template>

<script>

export default {

  props: {
    route: {
      type: Object,
      default: () => ({
        name: '',
        params: {},
        query: {}
      }),
      required: true
    },
    avatar: {
      type: Object,
      default: () => ({})
    },
    hasAvatar: {
      type: Boolean,
      default: false
    },
    title: String,
  },

}
</script>
